export default "__VITE_ASSET__BytJPyor__"